module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Portknox.net","short_name":"Portknox","start_url":"/","background_color":"#000","theme_color":"#009EE0","display":"standalone","icon":"static/portknox_lock.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fc13ae6709d55b3fbdef33f00cea1893"},
    },{
      plugin: require('../node_modules/@mobile-reality/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleConsent":{"adStorage":"granted","analyticsStorage":"granted","functionalityStorage":"granted","personalizationStorage":"granted","adUserData":"granted","adPersonalization":"granted","wait_for_update":500},"googleTagManager":{"trackingId":"GTM-5LJRLX82","dataLayerName":"dataLayer"},"environments":["production","development"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
